var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M606 786L606 814",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 606.5,
    cy: 781.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M601.987 781.19C601.987 777.283 605.288 774.117 609.358 774.117C609.943 774.117 610.511 774.184 611.056 774.308C609.742 773.48 608.187 773 606.519 773C601.814 773 598 776.806 598 781.5C598 786.194 601.814 790 606.519 790C608.814 790 610.895 789.093 612.427 787.62C611.492 788.032 610.454 788.263 609.358 788.263C605.288 788.263 601.987 785.096 601.987 781.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M615.402 780.6L615.37 778.146L613.535 779.719L611.304 779.056L612.112 781.337L610.765 783.381L613.1 783.218L614.499 785.144L615.133 782.763L617.345 781.909L615.402 780.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.40914f0ef4071ad0772d89b14bd24d91.svg";
export { ForwardRef as ReactComponent };